import axios from "axios";
import AppData from "../config/appData.json";

// ✅ Create a global Axios instance
const api = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    channel: AppData.CHANNEL_NAME, // Set default channel
  },
});

// ✅ Request Interceptor (Adds Authorization & Serial Number)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const serialNumber = localStorage.getItem("serialNumber");

    if (token) {
      // console.log("token exist")
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    if (serialNumber) {
      // console.log("serial no exist")
      config.headers["ddsn"] = serialNumber;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor (Handles Unauthorized Errors)
api.interceptors.response.use(
  (response) => response.data, // Extract only response data
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized! Logging out...");
      localStorage.removeItem("token");
      window.location.href = "/signin"; // Redirect to login
    }
    return Promise.reject(error);
  }
);

export default api;
